import { Map as ImmutableMap } from 'immutable';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useInterval } from 'react-use';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { authActions } from 'app-components/flux/auth';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { getBuildConfig } from 'app-components/utils/core/config';
import store from 'app-components/utils/redux-store';

import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { DIALOG_TYPE as DIALOG_CONFIRMATION, mkConfirmationDialogProps } from 'components/Dialogs/ConfirmationDialog';

const inactivityCountdownTimeoutInSeconds = getBuildConfig()?.inactivity_countdown_timeout_in_seconds || 30;

export const InactivityCountdown = styled.div`
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
`;

const id = uuidv4();

const CountDown = () => {
  const dispatch = useDispatch();
  const [countDown, setCountDown] = useState(inactivityCountdownTimeoutInSeconds);

  useInterval(() => setCountDown((count) => count - 1), countDown > 0 ? 1000 : null);

  useEffect(() => {
    if (countDown <= 0) {
      dispatch(authActions.authLogout({ reason: 'AUTH_LOGOUT_INACTIVE' }, { context: 'inactivityCountdownValue' }));
    }
  }, [dispatch, countDown]);

  return (
    <DialogContent>
      <Typography variant='titleRegular'>
        To ensure security of your session please confirm that you want to continue or you will be logged out
        automatically.
      </Typography>
      <InactivityCountdown>{countDown}</InactivityCountdown>
    </DialogContent>
  );
};

export const createCountDownDialogAction = () =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      id,
      type: DIALOG_CONFIRMATION,
      allowNesting: true,
      props: ImmutableMap(
        mkConfirmationDialogProps({
          title: 'Session Inactivity',
          content: <CountDown />,
          confirmLabel: 'Continue',
          confirmAction: () => {
            store?.dispatch(rootUiActions.removeDialog(id));
          },
          denyLabel: 'Logout',
          denyAction: () => {
            store?.dispatch(
              authActions.authLogout(
                { reason: 'AUTH_LOGOUT_USER_INITIATED' },
                { context: 'inactivityCountdownLogoutAction' },
              ),
            );
          },
          dialogCloseAliasAction: 'CONFIRM',
        }),
      ),
    }),
  );

export default CountDown;
